:host {
  overflow-y: hidden;
  background: var(--white-layout-301-level-0-elevation);
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  .grid-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    [hidden] {
      display: none;
    }

    #page-title {
      padding-top: 17px;
      padding-left: 24px;
    }
  }

  .customer-wrapper {
    max-width: 950px;

    [hidden] {
      display: none;
    }
  }
}
